const axios = require("axios").default;

const baseUrl = process.env.VUE_APP_API_URL || 'https://api.ebsr.in/'

const api = axios.create({
    baseURL: baseUrl, headers: {
        "Content-type": "application/json",
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0',
    }
});

function apiUrl(path = '') {
    if (!path) return baseUrl
    if (path.startsWith('http')) return path
    const root = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
    return `${root}${path.startsWith('/') ? path : `/${path}`}`
}

function assetUrl(path = '') {
    if (!path) return ''
    return `${baseUrl}${String(path).replace(/^\//, '')}`
}

export {
    api,
    baseUrl,
    apiUrl,
    assetUrl,
}
